import React, { Component } from '../../lib/react'
import connect from "react-redux/es/connect/connect"
import { Link } from "react-router";
import {Icon, List, Divider, Dropdown, Menu, message, Spin} from 'antd'
import LinkComponent from '../LinkComponent/LinkComponent';
import Lock from "./ItemAction";
import Like from "../Like";
import ItemAction from './ItemAction';
import DateViewer from '../DateViewer';
import Img from 'react-image';

import icons from "../icons/icons";
import cn from "classnames";

import { auth } from '../../services/firebase/firebase'
import { saveEventAction } from "../../actions/userStoreActions";
import { popupPaymentStore, selectPaymentEvent } from "../../actions/optionsStoreActions";

import './EventItem.less';

const eventTitleLengthFromWidth = {
  320: 50,
  480: 130,
  576: 25,
  768: 20,
  992: 45,
  1020: 45,
  1200: 50,
  1600: 50
};

class EventItem extends Component {
  constructor(props) {
    super(props);
    let isLikedState = false;
    if (props.item && props.item.liked_users) {
      isLikedState = props.item.liked_users.find(userId => userId === props.claims.user_id)
    }

    this.state = {
      width: 0,
      height: 0,
      likesCount: (props.item.liked_users && props.item.liked_users.length) || 0,
      isLikedState: isLikedState,
      liked_users: props.item.liked_users,
      userData: {}
    };
  }

  static getDerivedStateFromProps(props, state) {
    const { userData, userClaims } = props.user;

    if (userData !== state.userData || userClaims !== state.userClaims) {
      return {
        userData: userData,
        userClaims: userClaims,
        loading: false
      };
    }

    return null;
  }

  localHandlerLikes(item) {
    let { likesCount, isLikedState, liked_users } = this.state;
    const { claims } = this.props;
    const userId = claims && claims.user_id;

    if (userId && !isLikedState) {
      this.props.handleLike(item);

      this.setState({
        isLikedState: !isLikedState,
        likesCount: likesCount + 1,
        activeLike: true,
        liked_users : [userId, ...liked_users]
      })
    } else if (userId && isLikedState) {
      this.props.handleLike(item);
      let likes = liked_users.filter(id => id !== userId)

      this.setState({
        isLikedState: !isLikedState,
        likesCount: likesCount - 1,
        activeLike: false,
        liked_users : likes
      })
    }
  }

  async eventSaveHandler(id) {
    const uid = auth().currentUser.uid;
    const { savedEvents, saveLoadingOptions } = this.props.user;
    const { messageType, error } = saveLoadingOptions;
    const { saveEventAction, updateSaveEventId } =this.props;

    updateSaveEventId(id);

    let newSavedEventList = [...savedEvents];
    let typeOfSaving;

    if (newSavedEventList.indexOf(id) === -1) {
      typeOfSaving = 'new';
      newSavedEventList = [...newSavedEventList, id];
    } else {
      typeOfSaving = 'delete';
      newSavedEventList = savedEvents.filter(event => event !== id);
    }

    saveEventAction({uid: uid, newSavedEventList: newSavedEventList});

    if (messageType && messageType === 'success' && typeOfSaving === 'new') {
      return message.success('Event is added to Saved Events');
    }
    if (messageType && messageType === 'success' && typeOfSaving === 'delete') {
      return message.success('Event is removed from Saved Events');
    }
    if (messageType && messageType === 'error') {
      return message.error(error.message);
    }
  }

  handlerPayment(type, eventId) {
    this.props.popupPaymentStore(type);
    this.props.selectPaymentEvent(eventId);
  }

  paymentPermissions (item, userData) {
    const { channels, user } = this.props;
    const { userType } = user && user.userClaims;
    const isAdmin = userType && (userType === 'Admin');

    const channelId = item.channel && item.channel.id;
    const isBoughtEvent = userData && userData.boughtEvents && userData.boughtEvents.find((eventId) => eventId === item.id);
    const paidEvent = item.paidBlock && item.paidBlock === "blocked";

    let eventOwnerId = false;
    channels && channels.map(channel => {
      if (channel.id === channelId) {
        if (!channel.ownerId) { // if channel haven't ownerId it's free channel
          eventOwnerId = true
        } else {
          eventOwnerId = channel.ownerId.find(ownerId => ownerId === user.uid);
        }
      }
    });

    return paidEvent ? (isAdmin || !!isBoughtEvent || !!eventOwnerId) : true;
  }

  render() {
    const { item, user } = this.props;
    const { userData, isLikedState, liked_users } = this.state;
    const { savedEvents, saveLoadingOptions } = user;
    const { saveLoading } = saveLoadingOptions;

    let isSaved = false;
    savedEvents && savedEvents.forEach(id => item.id === id ? isSaved = true : null);
    const lockText = (
      <span>
        Subscription <br /> needed
      </span>
    );

    const menu = (
      <Menu>
        <Menu.Item>
          <Link to={`/Event_Editor/${item.id}`}>
            <span>Edit</span>
          </Link>
        </Menu.Item>
        <Menu.Item>
          <span onClick={() => this.props.handleDeleteEvent(item)}>Delete</span>
        </Menu.Item>
      </Menu>
    );

    const currentWidth = this.state.width;
    const keys = Object.keys(eventTitleLengthFromWidth);
    const markers = keys.map(key => (currentWidth >= parseInt(key)) ? true : false);
    let indexEl = 0;
    markers.forEach((boolean, index) => boolean ? indexEl = index : null );
    const currentLength = eventTitleLengthFromWidth[keys[indexEl]];
    const title = (item.title.length > currentLength) ? item.title.slice(0, currentLength) + '...' : item.title;

    const { savingEvent_id } = this.props;
    const saveEventButton = (saveLoading && item.id === savingEvent_id) ? (
        <Icon type="loading" style={{fontSize: '18px'}} />
      ) : (
        <Icon
          component={isSaved ? icons.savedEventsFilled : icons.savedEvents}
          className={cn({ saved: isSaved }, { disabledButton: true})}
          onClick={() => this.eventSaveHandler(item.id)}
        />
      );

    const isUnblocked = item ? this.paymentPermissions(item, userData) : false;

    const loader = <Spin className="preloader" />;

    return (
      <List.Item className="list-item-vertical">
        <div className="list-item-vertical-image">
          {
            !isUnblocked && (
              <div
                className="image-hover"
                onClick={() => this.handlerPayment('payment', item.id)}
              >
                <Icon type="lock" />
              </div>
            )
          }
          <LinkComponent
            isShow
            className="channel"
            pathTo={`/watch/${item.id}`}
            pathFrom={this.props.pathFrom}
          >
            <Img
              src={item.thumbnail}
              loader={loader}
            />
          </LinkComponent>
          {item.locked && <Lock text={lockText } />}
        </div>
        <div className="list-item-vertical-content">
          <div className="list-item-title" title={item.title}>
            <span className="link">
              <Link
                className="channel"
                to={!!isUnblocked ? `/watch/${item.id}` : ''}
              >
                {title}
              </Link>
            </span>
          </div>
          <div className="list-item-text">
            <span className="link">
              <Icon component={icons.channels} />
              <Link
                className="channel"
                to={`/Channels/${item.channel.id}`}
              >
                {item.channel.title}
                </Link>
            </span>
          </div>
          <div className="list-item-date">
            <span>Event Date: </span>
            <DateViewer date={item.date}/>
          </div>

          <div className="list-item-meta">
            <div className="list-item-actions">
              <ItemAction component={icons.view} text={item.views || '0'} />
              <Divider type="vertical" />
              <Like
                component={icons.like}
                id={item.id || ''}
                liked_users={liked_users}
                localCount={this.state.likesCount}
                handleLike={() => this.localHandlerLikes(item, isLikedState)}
              />
            </div>

            <div className="list-item-additional">
              {
                this.props.pageType !== 'myProfile' && saveEventButton
              }
              {
                this.props.pageType === 'myProfile' && (
                  <div className="myProfile__dropdown-menu">
                    <Dropdown overlay={menu}>
                      <a className="ant-dropdown-link" href="#">
                        <Icon type="ellipsis" style={{fontSize:'26px'}} />
                      </a>
                    </Dropdown>
                  </div>
                )
              }
            </div>
          </div>
          {
            item.paidBlock && (
              <div className="paid-status">
                <Icon type={`${!isUnblocked ? 'lock' : 'unlock'}`} />
              </div>
            )
          }
        </div>
      </List.Item>
    )
  }
}

export default connect(
  (state) => {
    return {
      user: state.user,
      channels: state.data.channels,
    };
  },
  {
    saveEventAction, popupPaymentStore, selectPaymentEvent
  }
)(EventItem);



// WEBPACK FOOTER //
// ./src/components/Items/EventItem.js